export default __webpack_public_path__ + "static/media/process3.11b007c6.png";